import { Typography } from '@altibox/lte-salgskanaler-design-system-component-lib';
import { styled } from 'styled-components';

import { breakpointTablet } from 'src/styles/breakpoints';
import { spacing2, spacing3, spacing4, spacing5 } from 'src/styles/spacing';

export const StyledDescriptionTitle = styled(Typography)`
  font-weight: bold;
  margin-top: ${spacing3};
  margin-bottom: ${spacing2};

  @media (min-width: ${breakpointTablet}) {
    margin-top: ${spacing4};
  }
`;

export const StyledDescription = styled(Typography)`
  margin-bottom: ${spacing2};

  @media (min-width: ${breakpointTablet}) {
    margin-bottom: ${spacing3};
  }
`;

export const StyledDecoderContainer = styled.div`
  margin-bottom: ${spacing4};

  @media (min-width: ${breakpointTablet}) {
    margin-bottom: ${spacing5};
  }
`;
